module.exports = __webpack_public_path__ + "img/pending_zone.483e0d10.svg";